(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pp-filter-complete"] && !Shopify.designMode) return;
  try {
    

function ppv2Windows(product, selections, omitted) {
  const methods = omitted === 'sadd' ? [] : (selections.sadd || []);
  const months = omitted === 'month' ? [] : (selections.month || []).map(Number);
  return (product.windows || []).filter(window =>
    product.sadd.includes(window.method) &&
    (!methods.length || methods.includes(window.method)) &&
    (!months.length || months.some(month => window.months.includes(month)))
  );
}
function ppv2Matches(product, selections, omitted, includeMixes = true) {
  if (!includeMixes && product.fargblandning) return false;
  for (const key of ['blomfarg', 'hojd', 'anvandning', 'lage', 'availability']) {
    if (key === omitted) continue;
    const selected = selections[key] || [];
    if (selected.length && !selected.some(value => (product[key] || []).includes(value))) return false;
  }
  const methods = omitted === 'sadd' ? [] : (selections.sadd || []);
  const months = omitted === 'month' ? [] : (selections.month || []);
  if (months.length) return ppv2Windows(product, selections, omitted).length > 0;
  return !methods.length || methods.some(method => product.sadd.includes(method));
}
if (!customElements.get('pp-filter-complete')) {
  customElements.define('pp-filter-complete', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.grid = this.querySelector('[data-ppv2-grid]');
      this.panel = this.querySelector('.ppv2__panel');
      this.overlay = this.querySelector('[data-ppv2-overlay]');
      this.opener = this.querySelector('[data-ppv2-open]');
      this.inputs = [...this.querySelectorAll('input[data-ppv2-group]')];
      this.mixControl = this.querySelector('[data-ppv2-mixes]');
      this.nowControl = this.querySelector('[data-ppv2-now]');
      this.sortControl = this.querySelector('[data-ppv2-sort]');
      this.keys = ['blomfarg', 'hojd', 'anvandning', 'sadd', 'month', 'lage', 'availability'];
      let review = {}, invalid = false;
      const parse = (value, fallback) => { try { return JSON.parse(value) ?? fallback; } catch { return fallback; } };
      if (this.dataset.reviewMode === 'true') {
        const source = parse(this.querySelector('[data-ppv2-review]').textContent, null);
        if (!source || !Array.isArray(source.products)) invalid = true;
        else review = Object.fromEntries(source.products.map(product => [String(product.id).split('/').pop(), product]));
      }
      this.products = [...this.querySelectorAll('[data-ppv2-card]')].map(card => {
        const raw = this.dataset.reviewMode === 'true' ? review[card.dataset.id] : Object.fromEntries(['blomfarg', 'hojd', 'anvandning', 'sadd', 'lage', 'fargblandning', 'windows'].map(key => [key, parse(card.dataset[key], key === 'fargblandning' ? false : [])]));
        if (!raw) invalid = true;
        const product = {card, id:card.dataset.id, title:card.dataset.title, price:Number(card.dataset.price), rank:Number(card.dataset.rank), availability:[card.dataset.availability]};
        for (const key of ['blomfarg', 'hojd', 'anvandning', 'sadd', 'lage']) product[key] = Array.isArray(raw?.[key]) ? raw[key] : [];
        product.fargblandning = raw?.fargblandning === true;
        product.windows = Array.isArray(raw?.windows) ? raw.windows.filter(window => window && typeof window.method === 'string' && Array.isArray(window.months)).map(window => ({method:window.method, months:window.months.map(Number).filter(month => Number.isInteger(month) && month >= 1 && month <= 12), conditions:typeof window.conditions === 'string' ? window.conditions : ''})) : [];
        card.querySelector('[data-ppv2-mix-label]').hidden = !product.fargblandning;
        return product;
      });
      this.querySelector('[data-ppv2-error]').hidden = !invalid;
      this.inputs.forEach(input => input.addEventListener('change', () => this.update(), {signal}));
      this.mixControl.addEventListener('change', () => this.update(), {signal});
      this.sortControl.addEventListener('change', () => this.update(), {signal});
      this.querySelectorAll('[data-ppv2-reset]').forEach(button => button.addEventListener('click', () => this.reset(), {signal}));
      this.opener.addEventListener('click', () => this.open(), {signal});
      this.querySelectorAll('[data-ppv2-close]').forEach(button => button.addEventListener('click', () => this.close(), {signal}));
      this.overlay.addEventListener('click', () => this.close(), {signal});
      this.panel.addEventListener('keydown', event => this.trapFocus(event), {signal});
      this.nowControl.addEventListener('click', () => {
        const current = new Intl.DateTimeFormat('sv-SE', {timeZone:'Europe/Stockholm',month:'numeric'}).format(new Date());
        const active = this.nowControl.getAttribute('aria-pressed') === 'true';
        this.inputs.filter(input => input.dataset.ppv2Group === 'month').forEach(input => {input.checked = !active && input.value === current;});
        this.update();
      }, {signal});
      this.setDetails();
      this.update();
    }
    disconnectedCallback() { this.close(false); this.abortController?.abort(); this.initialized = false; }
    setDetails() { this.querySelectorAll('[data-ppv2-details]').forEach(detail => { detail.open = false; }); }
    selections() { return Object.fromEntries(this.keys.map(key => [key, this.inputs.filter(input => input.dataset.ppv2Group === key && input.checked).map(input => input.value)])); }
    update() {
      const selections = this.selections();
      const includeMixes = this.mixControl.checked;
      const active = this.inputs.filter(input => input.checked);
      const visible = this.products.filter(product => ppv2Matches(product, selections, undefined, includeMixes));
      const visibleIds = new Set(visible.map(product => product.id));
      this.products.forEach(product => {
        product.card.hidden = !visibleIds.has(product.id);
        const note = product.card.querySelector('[data-ppv2-sowing-note]');
        note.replaceChildren();
        note.hidden = !selections.month.length || product.card.hidden;
        if (!note.hidden) ppv2Windows(product, selections).forEach(window => {
          const line = document.createElement('p');
          const method = document.createElement('strong'); method.textContent = this.inputs.find(input => input.dataset.ppv2Group === 'sadd' && input.value === window.method)?.dataset.label || window.method;
          line.append(method);
          if (window.conditions) line.append(document.createTextNode(' · ' + window.conditions));
          note.append(line);
        });
      });
      this.inputs.forEach(input => {
        const candidate = {...selections, [input.dataset.ppv2Group]:[input.value]};
        const count = this.products.filter(product => ppv2Matches(product, candidate, undefined, includeMixes)).length;
        input.closest('label').querySelector('[data-ppv2-option-count]').textContent = count;
        input.disabled = count === 0 && !input.checked;
      });
      this.querySelector('[data-ppv2-count]').textContent = visible.length === 1 ? this.dataset.countOne : this.dataset.countText.replace('{count}', visible.length);
      this.querySelector('[data-ppv2-show]').textContent = visible.length === 1 ? this.dataset.showOne : this.dataset.showText.replace('{count}', visible.length);
      const activeCount = active.length + (includeMixes ? 0 : 1);
      this.querySelector('[data-ppv2-active]').textContent = activeCount ? `(${activeCount})` : '';
      this.nowControl.setAttribute('aria-pressed', String(selections.month.length === 1 && selections.month[0] === new Intl.DateTimeFormat('sv-SE', {timeZone:'Europe/Stockholm',month:'numeric'}).format(new Date())));
      this.querySelector('[data-ppv2-empty]').hidden = visible.length > 0;
      const chips = this.querySelector('[data-ppv2-chips]');
      chips.replaceChildren();
      const addChip = (label, onRemove, source) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'ppv2__chip'; button.textContent = label;
        button.setAttribute('aria-label', this.dataset.removeText.replace('{value}', label));
        const cross = document.createElement('span'); cross.textContent = '×'; cross.setAttribute('aria-hidden','true'); button.append(cross);
        button.addEventListener('click', () => {const index = [...chips.children].indexOf(button); onRemove(); this.update(); const next = chips.children[Math.min(index,chips.children.length-1)]; if (next) next.focus(); else if (!this.panel.hasAttribute('data-open')) this.opener.focus(); else source.focus();});
        chips.append(button);
      };
      active.forEach(input => addChip(input.dataset.label, () => {input.checked = false;}, input));
      if (!includeMixes) addChip(this.dataset.mixChip, () => {this.mixControl.checked = true;}, this.mixControl);
      if (activeCount) { const reset = document.createElement('button'); reset.type='button'; reset.className='ppv2__reset'; reset.textContent=this.dataset.resetText; reset.addEventListener('click', () => {this.reset(); this.opener.focus();}); chips.append(reset); }
      chips.hidden = !activeCount;
      const sort = this.sortControl.value;
      const sorted = [...this.products].sort((a,b) => sort === 'price-ascending' ? a.price-b.price || a.rank-b.rank : sort === 'price-descending' ? b.price-a.price || a.rank-b.rank : sort === 'title-ascending' ? a.title.localeCompare(b.title,'sv') : a.rank-b.rank);
      const currentOrder = [...this.grid.children];
      if (sorted.some((product,index) => currentOrder[index] !== product.card)) sorted.forEach(product => this.grid.append(product.card));
    }
    reset() { this.inputs.forEach(input => {input.checked = false;}); this.mixControl.checked = true; this.update(); }
    open() {
      if (this.panel.hasAttribute('data-open')) return;
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.panel.hidden = false;
      this.inertBackground = [];
      for (let node=this.panel; node.parentElement; node=node.parentElement) {
        for (const sibling of node.parentElement.children) if (sibling!==node && sibling!==this.overlay && !sibling.inert) {sibling.inert=true;this.inertBackground.push(sibling);}
      }
      this.panel.setAttribute('data-open',''); this.panel.setAttribute('role','dialog'); this.panel.setAttribute('aria-modal','true');
      this.overlay.hidden = false; this.opener.setAttribute('aria-expanded','true');
      this.panel.querySelector('[data-ppv2-close]').focus();
    }
    close(restore = true) {
      if (!this.panel?.hasAttribute('data-open')) return;
      this.panel.hidden = true;
      this.inertBackground?.forEach(element=>{element.inert=false;});
      this.panel.removeAttribute('data-open'); this.panel.removeAttribute('role'); this.panel.removeAttribute('aria-modal');
      this.overlay.hidden = true; this.opener.setAttribute('aria-expanded','false'); document.documentElement.style.overflow = this.previousOverflow || '';
      if (restore && this.previousFocus?.isConnected) this.previousFocus.focus();
    }
    trapFocus(event) {
      if (!this.panel.hasAttribute('data-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...this.panel.querySelectorAll('button,input:not(:disabled),summary,select,a[href]')].filter(element => element.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length-1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault(); last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault(); first.focus();}
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-product-premium-style"] && !Shopify.designMode) return;
  try {
    
  function insertPalettparadisetProductExcerpt() {
    if (!document.querySelector('.pp-product-premium-style .pp-product-assurance')) {
      return;
    }

    document.querySelectorAll('.collapsible-tab .collapsible-content .pp-scope').forEach((scope) => {
      const tab = scope.closest('.collapsible-tab');

      if (!tab || tab.previousElementSibling?.classList.contains('pp-product-excerpt')) {
        return;
      }

      const paragraphs = Array.from(scope.children).filter((element) => element.tagName === 'P');
      const source = paragraphs.find((paragraph) => paragraph.textContent.trim().length > 80) || paragraphs[0];

      if (!source) {
        return;
      }

      const excerpt = document.createElement('div');
      excerpt.className = 'pp-product-excerpt';
      excerpt.appendChild(source);
      tab.parentElement.insertBefore(excerpt, tab);
    });
  }

  function placePalettparadisetFavLabel() {
    const source = document.querySelector('.pp-product-premium-style .pp-fav-source');
    if (!source) return;
    const label = source.querySelector('.pp-fav');
    if (!label) { source.remove(); return; }
    const title = document.querySelector('[id*="__product-form"] .product-details-product-title');
    if (!title || title.parentElement.querySelector('.pp-fav')) return;
    title.insertAdjacentElement('afterend', label);
    source.remove();
  }

  function runPalettparadisetProductEnhancements() {
    insertPalettparadisetProductExcerpt();
    placePalettparadisetFavLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPalettparadisetProductEnhancements);
  } else {
    runPalettparadisetProductEnhancements();
  }

  document.addEventListener('shopify:section:load', runPalettparadisetProductEnhancements);

  } catch(e) { console.error(e); }
})();
})();
